import React from 'react'

import './menu-signs.scss'
import Signs from '../../atoms/signs/signs'

const MenuSigns = props => {
    // var news_info=props.dataProp
   
    return (
        <div className="f-header-horoscope-nav">
            <ul>
                {props.signs.map((sing, index) => {
                    return (
                        <Signs key={index} setPageChange={props.setPageChange} itemActive={props.activeSign === sing.titulo?true:false} title={sing.titulo} classIco={sing.iconoDelSigno} slug={sing.slug}/>
                    )
                })}
            </ul>
        </div>
    )
}

export default MenuSigns;
